import React from "react";
import { MergeFinancialAccountsResponse } from "../../../../common/dto/financialAccount/mergeFinancialAccounts/merge-financial-accounts-response.dto";
import { Collapsible } from "../../../general/Collapsible/Collapsible";
import styles from "./MultipleMatchingConflicts.module.scss";
import { MultipleMatchingConflictResolving } from "./MultipleMatchingConflictResolving";

interface Props {
    conflicts: MergeFinancialAccountsResponse["multipleMatchingConflicts"];
    multipleMatchingConflictsResolutions: Array<{
        fromDestination: number;
        toKeep: number;
    }>;
    onResolve: (
        resolutions: Array<{
            fromDestination: number;
            toKeep: number;
        }>,
    ) => void;
}

export const MultipleMatchingConflicts: React.FC<Props> = ({
    conflicts,
    multipleMatchingConflictsResolutions,
    onResolve,
}) => {
    const header = (
        <div className={styles.header}>
            <main>
                <p>
                    Following transactions from destination account have more
                    than one matching transaction in account to be merged. Can't
                    determine which transactions should be moved.
                </p>
            </main>
        </div>
    );

    return (
        <Collapsible header={header}>
            <div className={styles.multipleMatchingConflicts}>
                {conflicts.map((conflict) => (
                    <MultipleMatchingConflictResolving
                        key={conflict.transactionFromDestination.id}
                        conflict={conflict}
                        resolutions={multipleMatchingConflictsResolutions}
                        onResolve={onResolve}
                    />
                ))}
            </div>
        </Collapsible>
    );
};
